
import { Image, Text } from "@react-three/drei"
import { mainStore } from "../store"
import { __ } from "../utils"
import { useThree } from "@react-three/fiber"



export default function textRight({ maxWidth = 4.2, scale = 1, position = [0, 0, 0], positionX = 0, positionY = 0, positionZ = 0, text, exposant, expFont = false, offsetX = 0, offsetY = 0, fontsOw = false, fontSize = 0.15, lineHeight = 0.8, exposantHeight = false, expOffsetArray = [], specialRegFontSize = 0.05, children }, props) {

    /**
     * Setup
     */
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const { width } = useThree((state) => state.viewport)



    return <group scale={scale} position={position} {...props}>
        <Text
            maxWidth={(width < maxWidth) ? width : maxWidth}
            anchorX={'100%'}
            anchorY={'100%'}
            lineHeight={lineHeight}
            fontSize={fontSize}
            position={[width * (0.23 + positionX), 0 + positionY, 1.9 + positionZ]}
            font={fontsOw ? fontsOw : fonts.cm.title}
            color={colors.title}
            textAlign="right"
        >
            {children}
        </Text>


        {
            exposant && typeof exposant === "string" && <Text
                maxWidth={maxWidth}
                anchorX={0}
                anchorY={0}
                lineHeight={1.4}
                fontSize={exposantHeight ? exposantHeight : fontSize * 0.5}
                position={[width * (0.23 + positionX) + offsetX, 0 + offsetY, 1.9]}
                font={expFont ? expFont : fontsOw ? fontsOw : fonts.cm.title}
                color={colors.title}
                textAlign="left"
            >
                {exposant}
            </Text>
        }

        {
            exposant && typeof exposant === "object" &&

            exposant.map((exp, index) =>
                <Text
                    key={index}
                    maxWidth={maxWidth}
                    anchorX={0}
                    anchorY={0}
                    lineHeight={1.4}
                    fontSize={exposantHeight ? exp === '®' ? specialRegFontSize : exposantHeight : fontSize * 0.5}
                    position={[width * (0.23 + positionX) + (expOffsetArray[index][0]), positionY + (expOffsetArray[index][1]), 1.9]}
                    font={expFont ? expFont : fontsOw ? fontsOw : fonts.cm.title}
                    color={colors.title}
                    textAlign="left"
                >
                    {exp}
                </Text>
            )
        }

    </group>
}